import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Typography } from '@mui/material';
import AccordionDetails from '@mui/material/AccordionDetails';
import {
  SectionContainer,
  SectionIndicator,
  SectionTitle,
  StyledAccordion,
  StyledAccordionSummary
} from './mila.styles';

export const MilaSection = ({ title, content }: { title: string; content: string }) => {
  return (
    <SectionContainer>
      <SectionIndicator />
      <Box sx={{ flex: 1, overflow: 'hidden' }}>
        <StyledAccordion defaultExpanded disableGutters elevation={0}>
          <StyledAccordionSummary expandIcon={<ExpandMoreIcon />}>
            <SectionTitle variant="subtitle2">{title}</SectionTitle>
          </StyledAccordionSummary>
          <AccordionDetails sx={{ p: 0, pt: 1 }}>
            <Typography variant="body2" color="text.secondary">
              {content}
            </Typography>
          </AccordionDetails>
        </StyledAccordion>
      </Box>
    </SectionContainer>
  );
};
